import EventEmitter from './EventEmitter'

/**
 * Quality — 端末性能と prefers-reduced-motion の一元管理。
 * 3D層の各エフェクトはここを参照して、パーティクル数や演出の有無を決める。
 *
 * tier:
 *   'high' … デスクトップ想定。全エフェクト有効、pixelRatio 上限 2
 *   'low'  … タッチ小画面・低コア・低メモリ端末。流れ星なし・蛍減量、pixelRatio 上限 1.5
 *
 * reducedMotion が実行中に変わった場合は 'changed' を発火する。
 */
export default class Quality extends EventEmitter
{
  constructor()
  {
    super()

    const coarsePointer = window.matchMedia('(pointer: coarse)').matches
    const smallScreen = Math.min(window.innerWidth, window.innerHeight) < 768
    const lowCores = navigator.hardwareConcurrency !== undefined && navigator.hardwareConcurrency <= 4
    const lowMemory = navigator.deviceMemory !== undefined && navigator.deviceMemory <= 4

    this.tier = (coarsePointer && smallScreen) || lowCores || lowMemory ? 'low' : 'high'
    this.maxPixelRatio = this.tier === 'low' ? 1.5 : 2

    this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    this.reducedMotion = this.reducedMotionQuery.matches

    this.reducedMotionQuery.addEventListener('change', (event) =>
    {
      this.reducedMotion = event.matches
      this.trigger('changed')
    })
  }

  // GSAP のduration に掛ける係数。reduced-motion 時は 0 = 即時反映
  get motionScale()
  {
    return this.reducedMotion ? 0 : 1
  }
}
